import React, { useId } from 'react';

import { IconComponent } from '../../Icons/helpers';
import { InputControl } from '../components/InputControl';
import { InputField } from '../components/InputField';
import { InputFieldBody } from '../components/InputFieldBody';
import { InputFieldStartIcon } from '../components/InputFieldStartIcon';
import {
  CommonInputProps,
  CharacterCounterFeature,
  RawInputProps,
} from '../types';

type Props = {
  startIcon?: IconComponent;
} & CommonInputProps &
  CharacterCounterFeature &
  RawInputProps;

export const RawInputText = (props: Props) => {
  const id = useId();
  const {
    name,
    placeholder,
    error,
    disabled,
    helpText,
    extraHelpText,
    label,
    startIcon,
    hasCharacterCounter,
    maxLength,
    validations = {},
    condensed,
    value,
    onChange,
  } = props;
  const hasLengthError = maxLength ? Number(value?.length) > maxLength : false;

  if (!validations?.maxLength) validations.maxLength = maxLength;

  return (
    <InputControl
      error={error}
      helpText={helpText}
      extraHelpText={extraHelpText}
      value={value}
      hasCharacterCounter={hasCharacterCounter}
      maxLength={maxLength}
      label={label}
      htmlFor={id}
      condensed={condensed}
    >
      <InputField
        hasError={Boolean(error) || hasLengthError}
        disabled={disabled}
        paddingLeft={startIcon ? '5px' : '11px'}
        paddingRight="11px"
      >
        {startIcon && (
          <InputFieldStartIcon disabled={disabled} icon={startIcon} />
        )}
        <InputFieldBody
          disabled={disabled}
          placeholder={placeholder}
          id={id}
          name={name}
          validations={validations}
          value={value}
          onChange={onChange}
        />
      </InputField>
    </InputControl>
  );
};
